import { Navigate, Outlet, RouterProvider, createHashRouter } from 'react-router-dom';
import { Administration, adminRoutes } from './components/admin';
import Header from './components/nav/header';
import Org from './components/org/org';
import { RestAdminConsole, restAdminRoutes } from './components/wsadmin';
import { OmsUsers } from './components/user/oms-users-main';
import useAuth from './hook/useAuth';
import ErrorPage from './components/error-page';
import FrenchQueue from './components/french/french-queue';

export enum RoutePath {
    Hierarchy = 'hierarchy',
    FrenchQueue = 'manage',
    OmsUsers = 'users',
    Administration = 'admin',
    RestAdminConsole = 'restadmin',
}

export const parseRoutePath = (routePath: RoutePath) => '#/' + routePath;

export default function Router() {
    const { isRestAdminOnly } = useAuth()

    const getDefault = () => {
        if (isRestAdminOnly) {
            return '/' + RoutePath.RestAdminConsole
        } else {
            return '/' + RoutePath.Hierarchy
        }
    }

    const router = createHashRouter([
        {
            path: '/',
            element: <div className="oms-container px-3">
                <Header />
                <main id="main-content"><Outlet /></main>
            </div>,
            children: [
                { 
                    index: true, 
                    element: <Navigate to={getDefault()} replace /> 
                },
                {
                    path: RoutePath.Hierarchy,
                    element: <Org />
                },
                {
                    index: true,
                    path: RoutePath.FrenchQueue,
                    element: <FrenchQueue />
                },
                {
                    path: RoutePath.OmsUsers,
                    element: <OmsUsers />
                },
                {
                    path: RoutePath.Administration,
                    element: <Administration />,
                    children: adminRoutes
                },
                {
                    path: RoutePath.RestAdminConsole,
                    element: <RestAdminConsole />,
                    children: restAdminRoutes
                },
                {
                    path: '*',
                    element: <ErrorPage>Resource not found</ErrorPage>
                }
            ]
        }
    ])

    return <RouterProvider router={router} />;
}
